import { getContentfulSettings } from '@belong/contentful';
import { logger } from '@belong/logging';
import { loadMobileCampaigns, offerContentManager } from '@belong/offers';
import { ICatalogOffer } from '@belong/types/offer';
import { IProductData } from '../loadProductData';

export const initOfferContentManager = async (products: IProductData, correlationId: string): Promise<void> => {
  const offers: ICatalogOffer[] = Object.values(products).reduce((acc, item) => [...acc, ...(item?.offers ?? [])], []);

  // If no offers have been loaded then don't load campaigns, as there will be no offers to display
  if (!offers.length) {
    logger.debug('initOfferContentManager() - Skipping campaign load as no offers found');
    offerContentManager.init({});
    return;
  }

  // Check for campaigns for the loaded offers
  const campaignCodes = [...new Set(offers.map(offer => offer.groupingId))];
  const campaigns = await loadMobileCampaigns(correlationId, getContentfulSettings(), campaignCodes);

  // Set the offers and campaigns in the offer content manager
  offerContentManager.init({ offers, campaigns });
};
